import classNames from 'classnames';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { type ProductDetailContext } from '../../types/types';
import { AccordionIcon, CaptionTitle } from './AccordionIcon';
import styles from './AccordionContainer.module.scss';

interface AccordionTitleProps {
    readonly caption: string;
    readonly className?: string;
    readonly showIcon?: boolean;
}

const AccordionTitle = ({
    caption,
    className,
    showIcon = true,
}: AccordionTitleProps): JSX.Element => {
    const { isMydays } = useFragmentContext<ProductDetailContext>();

    const title =
        caption === CaptionTitle.MoreDetails && !isMydays ? CaptionTitle.UsefulInfo : caption;

    return (
        <div className="d-flex align-items-center">
            {showIcon && <AccordionIcon caption={title} />}
            <div className={classNames('flex-grow-1', styles.accordionTitle, className)}>
                {title}
            </div>
        </div>
    );
};

AccordionTitle.displayName = 'AccordionTitle';

export { AccordionTitle };
